import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function Hero() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '30%']);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  return <div ref={ref} className="relative h-screen w-full overflow-hidden flex items-center justify-center" data-id="element-45">
      {/* Background Image with Parallax */}
      <motion.div style={{
      y,
      opacity
    }} className="absolute inset-0 z-0" data-id="element-46">
        <div className="absolute inset-0 bg-black/40 z-10" data-id="element-47" />
        <img src="https://images.unsplash.com/photo-1541745537411-b8046dc6d66c?q=80&w=2576&auto=format&fit=crop" alt="Wood fired pizza oven" className="w-full h-full object-cover" data-id="element-48" />
      </motion.div>

      {/* Content */}
      <div className="relative z-20 text-center px-4 max-w-4xl mx-auto" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-50">
          <span className="block text-[#FFF8E7] text-xl md:text-2xl font-serif italic mb-4 tracking-wider" data-id="element-51">
            Autentica Pizzeria Italiana
          </span>
          <h1 className="text-7xl md:text-9xl text-[#FFF8E7] mb-6 drop-shadow-lg transform -rotate-2" data-id="element-52">
            Duelistarena
          </h1>
          <p className="text-[#FFF8E7] text-lg md:text-xl max-w-2xl mx-auto font-light leading-relaxed drop-shadow-md" data-id="element-53">
            Wood-fired tradition in the heart of London.
            <br data-id="element-54" />
            Where every crust tells a story of Naples.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1,
        duration: 1
      }} className="mt-12" data-id="element-55">
          <a href="#menu" className="inline-block px-8 py-3 bg-[#D4735E] text-[#FFF8E7] text-xl font-bold rounded-sm border-2 border-[#FFF8E7] hover:bg-[#8B1E3F] transition-colors duration-300 shadow-lg" data-id="element-56">
            View Menu
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div animate={{
      y: [0, 10, 0]
    }} transition={{
      repeat: Infinity,
      duration: 2
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 text-[#FFF8E7]" data-id="element-57">
        <ChevronDown size={32} data-id="element-58" />
      </motion.div>
    </div>;
}